import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export var formatUserListData = function formatUserListData(data) {
  var result = Array.isArray(data) ? data.map(function (original) {
    return {
      id: original.id,
      LastName: original.surname,
      FirstName: original.givenName,
      userName: original.email,
      Email: original.email,
      AvatarUrl: original.avatarUrl,
      LastAccessSolution: original.lastAccess && original.lastAccess.solutionName,
      LastAccessTime: original.lastAccess && original.lastAccess.lastAccessDate,
      solution: original.assignedSolutions.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          roles: item.roles.map(function (v) {
            return _objectSpread(_objectSpread({}, v), {}, {
              id: v.id,
              displayName: v.displayName
            });
          }),
          subscription: item.roles && item.roles[0].userSubscriptions && item.roles[0].userSubscriptions[0]
        });
      }),
      sfxRole: original.assignedSfxRoles,
      FullName: original.fullName
    };
  }) : [];
  return result;
};
export var formatCreateUserData = function formatCreateUserData(tableList, orgId) {
  var result = tableList.map(function (i) {
    var solutionRoleIds = i.solution.filter(function (l) {
      return !l.subscription;
    }).map(function (s) {
      return s.roles;
    }).flat().map(function (r) {
      return r.id;
    });
    var sfxRoleIds = i.sfxRole ? i.sfxRole.map(function (n) {
      return n.id;
    }) : [];
    var UserSubscriptionIdsToBeUsed = i.solution.filter(function (s) {
      return s.subscription;
    }).map(function (r) {
      return r.subscription && r.subscription.objectID;
    }) || [];
    return {
      orgId: orgId,
      givenName: i.FirstName.trim(),
      surname: i.LastName.trim(),
      userName: i.userName.trim(),
      UserSubscriptionIdsToBeUsed: UserSubscriptionIdsToBeUsed,
      UserSubscriptionIdsToBeUnlinked: [],
      solutionRoleIds: solutionRoleIds,
      sfxRoleIds: sfxRoleIds
    };
  });
  return result;
};
export var formatUpdateUserData = function formatUpdateUserData(formData, selectedUser, orgId) {
  var userName = formData.userName,
      FirstName = formData.FirstName,
      LastName = formData.LastName,
      sfxRole = formData.sfxRole,
      solution = formData.solution;
  var solutionRoleIds = solution.filter(function (l) {
    return !l.subscription;
  }).map(function (s) {
    return s.roles;
  }).flat().map(function (r) {
    return r.id;
  });
  var sfxRoleIds = sfxRole ? sfxRole.map(function (n) {
    return n.id;
  }) : [];
  var initialSubscriptionIds = selectedUser.solution.filter(function (i) {
    return i.subscription;
  }).map(function (l) {
    return l.subscription && l.subscription.objectID;
  });
  var currentSubscriptionIds = solution.filter(function (i) {
    return i.subscription;
  }).map(function (l) {
    return l.subscription && l.subscription.objectID;
  });
  var UserSubscriptionIdsToBeUnlinked = initialSubscriptionIds.filter(function (i) {
    return !currentSubscriptionIds.includes(i);
  });
  var result = {
    id: selectedUser.id,
    orgId: orgId,
    givenName: FirstName.trim(),
    surname: LastName.trim(),
    userName: userName,
    solutionRoleIds: solutionRoleIds,
    UserSubscriptionIdsToBeUsed: currentSubscriptionIds,
    UserSubscriptionIdsToBeUnlinked: UserSubscriptionIdsToBeUnlinked,
    sfxRoleIds: sfxRoleIds
  };
  return result;
}; // In order to generate subscription select options, Use 'defaultSubscription' to mark used user-type subscription.

export var formatSelectedUsersSubscription = function formatSelectedUsersSubscription(selectedUser) {
  if (selectedUser) {
    var initialFormData = _objectSpread(_objectSpread({}, selectedUser), {}, {
      solution: []
    });

    var solution = selectedUser.solution;

    if (solution && solution.length) {
      initialFormData.solution = solution.map(function (i) {
        if (i.subscription && i.roles) {
          return _objectSpread(_objectSpread({}, i), {}, {
            defaultSubscription: _defineProperty({}, i.roles[0].id, i.subscription),
            subscription: _objectSpread(_objectSpread({}, i.subscription), {}, {
              default: true
            })
          });
        } else {
          return _objectSpread({}, i);
        }
      });
    }

    return initialFormData;
  } else {
    return {};
  }
};
export var formatInviteUsersData = function formatInviteUsersData(tableList) {
  return tableList.map(function (i) {
    return {
      email: i.userName,
      surname: i.LastName,
      givenName: i.FirstName,
      requestedSolutions: i.selectedSolution && i.selectedSolution.length ? i.selectedSolution.map(function (j) {
        return {
          solutionId: j.id,
          solutionName: j.name
        };
      }) : []
    };
  });
};